import { useMemo } from 'react';
import { FieldType, SourceType } from 'components/organisms/tasks/fields';
import { useAccountCurrency } from 'hooks/use-account-currency';
import { useTranslation } from 'hooks/use-translation';
import { getCurrencyLabel } from 'utils/currency';
import { getRandomColor } from '../get-random-color';
export const useCurrencyField = (fieldId)=>{
    const fieldLabel = useTranslation('project.fields.currency');
    const currencyMap = useAccountCurrency();
    const isLoading = useMemo(()=>currencyMap == null, [
        currencyMap
    ]);
    return useMemo(()=>{
        var _Object_values, _ref;
        return {
            currencyField: {
                fieldId,
                fieldName: 'currency',
                fieldLabel,
                type: FieldType.SingleSelect,
                optionsAvailable: true,
                customField: false,
                private: false,
                metaData: {
                    options: ((_Object_values = Object.values((_ref = currencyMap === null || currencyMap === void 0 ? void 0 : currencyMap.all) !== null && _ref !== void 0 ? _ref : {})) !== null && _Object_values !== void 0 ? _Object_values : []).map(({ currency })=>({
                            label: getCurrencyLabel(currency),
                            value: currency.currencyCode,
                            active: true,
                            color: getRandomColor(currency.currencyCode)
                        }))
                },
                sourceType: SourceType.Project
            },
            isLoading
        };
    }, [
        currencyMap === null || currencyMap === void 0 ? void 0 : currencyMap.all,
        fieldId,
        fieldLabel,
        isLoading
    ]);
};
